/**
 * Failed Payment Trigger Component
 *
 * Trigger: "failed a payment"
 * Shows: Stripe plan select (optional)
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';
import { StripePlanFields } from '../components/StripePlanFields';

export const FailedPaymentTrigger: FC<TriggerComponentProps> = ({
  automation,
  index,
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    const planName = automation.paymentPlanName;
    if (planName) {
      return <span>{t('automations.triggers.failedPaymentFor', { plan: planName })}</span>;
    }
    return <span>{t('automations.triggers.failedPayment')}</span>;
  }

  // Edit mode - show stripe plan selection
  return <StripePlanFields automation={automation} index={index} />;
};
